import React, { useState, useEffect } from 'react';
import styled, { keyframes, css } from 'styled-components';
import { useTranslation } from 'react-i18next';
import HButton from './HButton';
import SVG from './svg';
import { useSelector } from 'react-redux';

const fadeIn = keyframes`
  from {
    opacity: 0
  }
  to {
    opacity: 1
  }
`;

const fadeOut = keyframes`
  from {
    opacity: 1
  }
  to {
    opacity: 0
  }
`;

const slideDown = keyframes`
  from {
    transform: translateY(-100px);
  }
  to {
    transform: translateY(0px);
  }
`;

const slideUp = keyframes`
  from {
    transform: translateY(0px);
  }
  to {
    transform: translateY(-100px);
  }
`;

const Fullscreen = styled.div`
  position: fixed;
  z-index: 30;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.25);
  display: flex;
  justify-content: center;
  align-items: center;

  animation-duration: 0.25s;
  animation-timing-function: ease-out;
  animation-name: ${fadeIn};
  animation-fill-mode: forwards;

  ${(props) =>
    props.disappear &&
    css`
      animation-name: ${fadeOut};
    `}
`;

const ModalBlock = styled.div`
  width: 392px;
  height: 252px;
  background: white;
  border-radius: 4px;
  border: solid 1px #eeeff0;

  animation-duration: 0.25s;
  animation-timing-function: ease-out;
  animation-name: ${slideDown};
  animation-fill-mode: forwards;

  ${(props) =>
    props.disappear &&
    css`
      animation-name: ${slideUp};
    `}
`;

const TitleBlock = styled.div`
  .titleBox {
    width: 392px;
    height: 56px;
    border-radius: 4px 4px 0 0;
    margin: 0 0 0 0;
    background: #eeeff0;
  }

  .titleText {
    width: 300px;
    height: 25px;
    margin: 15px 0 0 19px;
    font-family: Source Sans Pro;
    font-size: 20px;
    font-weight: 600;
    color: #59616a;
    text-align: left;
    float: left;
  }

  .closeIcon {
    width: 24px;
    height: 24px;
    margin: 16px 19px 0 0;
    float: right;
    cursor: pointer;
  }
`;

const ContentBlock = styled.div`
  .contentBox {
    width: 352px;
    margin: 24px 20px 32px 20px;
    font-family: Source Sans Pro;
    font-size: 15px;
    line-height: 1.33;
    color: #59616a;
  }
`;

const ButtonBlock = styled.div`
  width: 100%;
  position: absolute;
  bottom: 20px;
`;

const FirstLoginModal = ({ show, onClose, onRegisterDevice }) => {
  const { t } = useTranslation();
  const [animate, setAnimate] = useState(false);
  const [localVisible, setLocalVisible] = useState(show);

  const { odm } = useSelector(({ app }) => ({
    odm: app.odm,
  }));

  useEffect(() => {
    if (localVisible && !show) {
      setAnimate(true);
      setTimeout(() => setAnimate(false), 250);
    }
    setLocalVisible(show);
  }, [localVisible, show]);

  if (!animate && !localVisible) return null;

  const welcomeMessage = t('Welcome to 3DiscCloud !').replace('3DiscCloud', odm.app_name);

  return (
    <Fullscreen disappear={!show}>
      <ModalBlock disappear={!show}>
        <TitleBlock>
          <div className="titleBox">
            <div className="titleText">{welcomeMessage}</div>
            <div className={'closeIcon'} onClick={onClose}>
              <SVG
                name="close"
                color="#878D93"
                colorOver={odm.main_color_hover}
                colorOut="#878D93"
                colorDown={odm.main_color}
              />
            </div>
          </div>
        </TitleBlock>
        <ContentBlock>
          <div className="contentBox">
            {t('Would you like to register a new device now?')}
          </div>
        </ContentBlock>
        <ButtonBlock>
          <HButton
            category="Primary"
            size="Medium"
            text={t('Register Device').toUpperCase()}
            onClick={onRegisterDevice}
            margin="0 20px 0 0"
            float="right"
          />
          <HButton
            category="Secondary"
            size="Medium"
            text={t('Later').toUpperCase()}
            onClick={onClose}
            margin="0 16px 0 0"
            float="right"
          />
        </ButtonBlock>
      </ModalBlock>
    </Fullscreen>
  );
};

export default FirstLoginModal;